import React from 'react'
import * as Reakit from 'reakit/Tab'

import { useTabsContext } from './tabs'

export function TabPanel({ children, ...props }: Omit<React.HTMLProps<HTMLDivElement>, 'as'>) {
  const state = useTabsContext()

  return (
    <Reakit.TabPanel {...state} {...props}>
      {children}
    </Reakit.TabPanel>
  )
}
